"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assocIn = void 0;
const updateIn_1 = require("./updateIn");
const constantly_1 = require("./utils/constantly");
function assocIn(...args) {
    if (args.length !== 3) {
        return function curriedAssocIn(obj) {
            return assocIn([obj, ...args]);
        };
    }
    else {
        const [obj, path, v] = args;
        return updateIn_1.updateIn(obj, path, constantly_1.constantly(v));
    }
}
exports.assocIn = assocIn;
// assocIn({a: { b: { c: { d: 'redfd' }}}}, ['a', 'b', 'c', 'd'], (x => ));
// type t = keyof string;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzb2NJbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9hc3NvY0luLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHlDQUFzQztBQUN0QyxtREFBZ0Q7QUE0Q2hELFNBQWdCLE9BQU8sQ0FBQyxHQUFHLElBQVc7SUFDbEMsSUFBSSxJQUFJLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtRQUNuQixPQUFPLFNBQVMsY0FBYyxDQUFDLEdBQVE7WUFDbkMsT0FBUSxPQUFlLENBQUMsQ0FBQyxHQUFHLEVBQUUsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFDO1FBQzVDLENBQUMsQ0FBQTtLQUNKO1NBQU07UUFDSCxNQUFNLENBQUMsR0FBRyxFQUFFLElBQUksRUFBRSxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUM7UUFDNUIsT0FBTyxtQkFBUSxDQUFDLEdBQUcsRUFBRSxJQUFJLEVBQUUsdUJBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQzdDO0FBQ0wsQ0FBQztBQVRELDBCQVNDO0FBRUQsMkVBQTJFO0FBQzNFLHlCQUF5QiJ9